<template>
  <AdminLayout><ShippedOrdersTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import ShippedOrdersTable from './ShippedOrdersTable.vue';

export default {
  name: 'ShippedOrders',
  components: { AdminLayout, ShippedOrdersTable },
};
</script>
